export enum Models {
    yolo_v8_xs_backbone_coco = 'YOLO v8 xs',
    yolo_v8_s_backbone_coco = 'YOLO v8 s',
    yolo_v8_m_backbone_coco = 'YOLO v8 m',
    yolo_v8_l_backbone_coco = 'YOLO v8 l',
    yolo_v8_xl_backbone_coco = 'YOLO v8 xl',
    grounding_dino = 'Grounding Dino',
}

export enum Scope {
    PREPROCESSING = 'preprocessing',
    MODEL_ARCHITECTURE = 'modelArchitecture',
}

export interface Parameter {
    name: string;
    value: any;
    scope: string;
}

export interface SkillArchitectureDTO {
    id: string;
    parameter: Parameter[];
}
